<template>
  <div style="margin: 0">
    <v-data-table
      :expanded.sync="expanded"
      :footer-props="footerProps"
      :headers="headers"
      :items="filteredCustomers"
      :loading="loading"
      :single-expand="false"
      @click:row="clicked"
      class="mb-6"
      item-key="CustomerID"
      show-expand
    >
      <template v-slot:[`item.Email`]="{ item }">
        <a
          :href="'mailto:' + item.Email"
          @click.stop=""
          style="font-size: 12px; margin: 0; padding: 0"
          >{{ item.Email }}</a
        >
      </template>
      <template v-slot:[`item.Lizenzen`]="{ item }">
        <v-chip class="font-weight-medium" color="green lighten-5">{{
          item.Lizenzen
        }}</v-chip>
      </template>
      <template v-slot:[`item.Bestellungen`]="{ item }">
        <v-chip class="font-weight-medium" color="blue lighten-5">{{
          item.Bestellungen
        }}</v-chip>
      </template>
      <template v-slot:[`item.DatumAufnahme`]="{ item }">
        <span> {{ item.DatumAufnahme | formatDate }}</span>
      </template>

      <template v-slot:[`item.Kommentar`]="{ item }">
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <span
              class="d-inline-block text-truncate"
              style="max-width: 250px"
              v-on="on"
              >{{ item.Kommentar }}</span
            >
          </template>
          <span v-html="item.Kommentar"> </span>
        </v-tooltip>
      </template>

      <template v-slot:[`item.Licences`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn @click.stop="provision(item)" icon v-on="on">
              <v-icon color="cyan lighten-1" v-on="on"
                >fa-solid fa-upload</v-icon
              >
            </v-btn>
          </template>
          <span>Provisioning</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn @click.stop="editCustomer(item)" icon class="ml-1" v-on="on">
              <v-icon color="deep-orange lighten-1" v-on="on"
                >fas fa-user-edit</v-icon
              >
            </v-btn>
          </template>
          <span>Bearbeiten</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              @click.stop="
                () => {
                  customer = item;
                  newLizenze.show = true;
                }
              "
              class="mx-1"
              icon
              v-on="on"
            >
              <v-icon color="indigo lighten-1" v-on="on"
                >far fa-plus-square</v-icon
              >
            </v-btn>
          </template>
          <span>Lizenz hinzufügen</span>
        </v-tooltip>

        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              @click.stop="
                () => {
                  customer = item;
                  newDokument.show = true;
                }
              "
              icon
              v-on="on"
            >
              <v-icon color="purple lighten-1" v-on="on"
                >fas fa-file-medical</v-icon
              >
            </v-btn>
          </template>
          <span>Dokument erstellen</span>
        </v-tooltip>
      </template>

      <template v-slot:expanded-item="{ item }">
        <td :colspan="headers.length">
          <Lizenz :lizenzen="item.Licences"></Lizenz>
        </td>
      </template>
    </v-data-table>

    <provision-confirm
      :customer="customer"
      :showPopup="provisionDialog"
      v-if="provisionDialog.show"
    ></provision-confirm>

    <edit-customer
      :customer="customer"
      :showPopup="dialogConfig"
      v-if="dialogConfig.show"
    ></edit-customer>
    <add-lizenz
      :customer-id="customer.CustomerID"
      :show-popup="newLizenze"
      v-if="newLizenze.show"
    ></add-lizenz>
    <add-dokument
      :customer="customer"
      :show-popup="newDokument"
      v-if="newDokument.show"
    ></add-dokument>
  </div>
</template>

<script>
import { HTTP } from "../http";
import { EventBus } from "../eventbus";
import Lizenz from "../components/Lizenz";
import EditCustomer from "../components/EditCustomer";
import AddLizenz from "../components/AddLizenz";
import moment from "moment";
import AddDokument from "../components/AddDokument";
import ProvisionConfirm from "../components/ProvisionConfirm.vue";

export default {
  components: { AddDokument, Lizenz, EditCustomer, AddLizenz,ProvisionConfirm },

  methods: {
    filterCustomers() {
      this.filteredCustomers = [];
      if (!this.filter) {
        this.filteredCustomers = [...this.customers];
        this.expanded = [];
        return;
      }

      for (let i = 0; i < this.customers.length; i++) {
        let el = this.customers[i];

        let searchString = this.filter.toLocaleUpperCase();
        if (
          el.Firma != null &&
          el.Firma.toLocaleUpperCase().includes(searchString)
        ) {
          this.filteredCustomers.push(el);
          continue;
        }
        if (el.AP != null && el.AP.toLocaleUpperCase().includes(searchString)) {
          this.filteredCustomers.push(el);
          continue;
        }
        if (
          el.Email != null &&
          el.Email.toLocaleUpperCase().includes(searchString)
        ) {
          this.filteredCustomers.push(el);
          continue;
        }
        if (
          el.Lizenzen != null &&
          el.Lizenzen.toString().toLocaleUpperCase().includes(searchString)
        ) {
          this.filteredCustomers.push(el);
          continue;
        }
        if (
          el.Bestellungen != null &&
          el.Bestellungen.toString().toLocaleUpperCase().includes(searchString)
        ) {
          this.filteredCustomers.push(el);
          continue;
        }
        if (
          el.Kommentar != null &&
          el.Kommentar.toLocaleUpperCase().includes(searchString)
        ) {
          this.filteredCustomers.push(el);
          continue;
        }
        if (
          el.DatumAufnahme != null &&
          moment(el.DatumAufnahme)
            .format("DD.MM.YYYY")
            .toLocaleUpperCase()
            .includes(searchString)
        ) {
          this.filteredCustomers.push(el);
          continue;
        }

        if (el.Licences != null) {
          let numberOfMatches = el.Licences.filter((li) =>
            li.SerialNum.toLocaleUpperCase().includes(searchString)
          ).length;
          console.log(numberOfMatches);
          if (numberOfMatches > 0) {
            this.filteredCustomers.push(el);
            this.expanded.push(el);
          } else {
            if (this.expanded.includes(el)) {
              const index = this.expanded.indexOf(el);
              this.expanded.splice(index, 1);
            }
          }
        }
      }
    },

    editCustomer(item) {
      this.customer = item;
      this.dialogConfig.show = true;
    },
    provision(item) {
      this.customer = item;
      this.provisionDialog.show = true;
    },
    clicked(value) {
      if (this.expanded.includes(value)) {
        const index = this.expanded.indexOf(value);
        this.expanded.splice(index, 1);
      } else {
        this.expanded.push(value);
      }
    },
    reload() {
      HTTP.get("api/Customer").then((result) => {
        this.loading = false;
        this.customers = result.data;
        EventBus.$emit("update-counter", this.customers.length);
        this.filterCustomers();
      });
    },
  },
  created() {
    EventBus.$on("on-search", (value) => {
      this.filter = value;
      this.filterCustomers();
    });
    EventBus.$on("reload", () => {
      this.loading = true;
      this.reload();
    });
  },
  mounted() {
    this.reload();
  },
  data() {
    return {
      customer: {},
      loading: true,
      footerProps: {
        showFirstLastPage: true,
        itemsPerPageOptions: [12, 24, -1],
        firstIcon: "fas fa-angle-double-left",
        lastIcon: "fas fa-angle-double-right",
        prevIcon: "fas fa-angle-left",
        nextIcon: "fas fa-angle-right",
      },
      filter: "",
      dialogConfig: {
        show: false,
      },
      newLizenze: {
        show: false,
      },
      newDokument: {
        show: false,
      },
      provisionDialog: {
        show: false,
      },

      expanded: [],
      headers: [
        { text: "Firma", value: "Firma", width: 150 },
        { text: "Ansprechpartner", value: "AP", width: 150 },
        { text: "Email", value: "Email", width: 40 },
        { text: "Datum Aufnahme", value: "DatumAufnahme", width: 150 },
        { text: "Lizenzen", value: "Lizenzen", width: 100 },
        { text: "Best.", value: "Bestellungen", width: 80 },
        { text: "Kommentar", value: "Kommentar", width: 200 },
        { text: "Action", value: "Licences", width: 220 },
        { text: "", value: "data-table-expand" },
      ],
      customers: [],
      filteredCustomers: [],
    };
  },
};
</script>
<style>
.v-data-table-header tr {
  height: 56px;
  background: #e3f2fd;
}

.v-data-table-header tr th {
  font-size: 14px;
}
</style>
